import { Environment } from 'src/Environment';

const addBcaAndSelfServiceBasePath = (path: string) => {
  let prefix = Environment.current?.disabledFeatures
    ?.merchantRoutingForBcaAndSelfServiceAndUseBrowserRouter
    ? ''
    : '/merchant';

  return path === '' ? prefix : prefix + path;
};

// SOV
export const bizWalletProDashboardRoute = addBcaAndSelfServiceBasePath('/biz-wallet-pro-dashboard');
export const bizWalletProTransactionsRoute = addBcaAndSelfServiceBasePath(
  '/biz-wallet-pro-transactions',
);

export const paymentsDashboardRoute = addBcaAndSelfServiceBasePath('/payments-services-dashboard');
export const terminalsRoute = addBcaAndSelfServiceBasePath('/terminals');
export const transactionsRoute = addBcaAndSelfServiceBasePath('/transactions');
export const terminalTransactionsRoute = addBcaAndSelfServiceBasePath('/terminal-transactions');
export const documentsRoute = addBcaAndSelfServiceBasePath('/my-documents');
export const productsAndServicesRoute = addBcaAndSelfServiceBasePath('/products-and-services');
export const merchantProfileRoute = addBcaAndSelfServiceBasePath('/merchant-profile');
export const resetPasswordMerchantIdRoute = addBcaAndSelfServiceBasePath('/reset-password');
export const resetPasswordResendOtpRoute = addBcaAndSelfServiceBasePath('/resend-otp');
export const firstTimeLoginOtpRoute = addBcaAndSelfServiceBasePath('/first-time-otp');
export const resetPasswordOtpRoute = addBcaAndSelfServiceBasePath('/reset-password-otp');
export const setPasswordRoute = addBcaAndSelfServiceBasePath('/set-password');
export const businessCashAdvanceRoute = addBcaAndSelfServiceBasePath('/business-cash-advance');
export const businessCashAdvanceDashboardRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/dashboard',
);
export const businessCashAdvancePreApprovedRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/pre-approved',
);
export const businessCashAdvanceNoQualifyRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/no-qualify',
);
export const businessCashAdvanceCalculationRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/calculation',
);
export const businessCashAdvanceTopUpCalculationRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/top-up/calculation',
);
export const businessCashAdvanceTopUpContractRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/top-up/contract',
);
export const businessCashAdvanceDigitalTermsRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/digital-terms',
);
export const businessCashAdvanceApprovedRoute = addBcaAndSelfServiceBasePath(
  '/business-cash-advance/approved',
);
export const vodapayDealsRoute = addBcaAndSelfServiceBasePath('/vodapay-deals');
export const generatePaymentRequestRoute = addBcaAndSelfServiceBasePath(
  '/generate-payment-request',
);
export const merchantLoginRoute = addBcaAndSelfServiceBasePath('/');
export const postLogoutRoute = addBcaAndSelfServiceBasePath('/');
export const indexRoute = '/';
export const onboardingRoute = '/onboarding';
export const onboardingRoutePos = '/onboarding/pos';
export const onboardingRoutePosLogin = '/onboarding/pos/login';
export const onboardingBrokerRoute = '/onboarding/broker';
export const onboardingBrokerRoutePos = '/onboarding/broker/pos';
export const onboardingBrokerLoginRoute = '/onboarding/broker/login';
export const onboardingResetPasswordUserIdRoute = '/onboarding/broker/reset-password';
export const onboardingResetPasswordOtpRoute = '/onboarding/broker/reset-password-otp';
export const onboardingResetPasswordResendOtpRoute = '/onboarding/broker/resend-otp';
export const onboardingFirstTimeUser = '/onboarding/broker/first-time';
export const onboardingSetPasswordRoute = '/onboarding/broker/set-password';
export const onboardingLetsGetStartedRoute = '/onboarding/start';
export const onboardingBusinessTypeRoute = '/onboarding/business-type';
export const onboardingCreateAccountRoute = '/onboarding/create-account';
export const onboardingChooseSolutionRoute = '/onboarding/create-account/choose-solution';
export const onboardingContinueReferenceRoute = '/onboarding/continue/reference';
export const onboardingContinueOtpRoute = '/onboarding/continue/otp';
export const onboardingAgentLoginRoute = '/onboarding/agent-login';
export const onboardingAgentOtpRoute = '/onboarding/agent-otp';
export const onboardingLegacyDeclinedApp = '/onboarding/mob/application-declined';
export const onboardingDeclinedApplication = '/onboarding/pos/application-declined';
export const onboardingFeeSliderRoute = '/onboarding/pos/fee-slider';
export const onboardingProcessPaymentRoute = '/onboarding/pos/process-payment';
export const deviceActivationRoute = '/onboarding/pos/device-activation';

// reskin routes
export const onboardingBusinessTypeReskinRoute = '/onboarding/create-account/business-type';
export const onboardingChooseSolutionReskinRoute = '/onboarding/create-account/choose-solution';
export const onboardingBusinessDetailsReskinYourBusinessRoute =
  '/onboarding/create-account/your-business';
export const onboardingBusinessDetailsReskinYourBusinessAddressRoute =
  '/onboarding/create-account/your-business-address';
export const onboardingBusinessDetailsReskinYourBusinessIdsRoute =
  '/onboarding/create-account/your-business-ids';
export const onboardingYourDetailsReskinYourselfRoute = '/onboarding/create-account/your-details';
export const onboardingYourDetailsReskinSelfieRoute =
  '/onboarding/create-account/your-details-selfie';
export const onboardingYourDetailsReskinBankingRoute =
  '/onboarding/create-account/your-details-banking-details';
export const onboardingUploadDocumentsReskinRoute = '/onboarding/create-account/upload-documents';
export const onboardingConfirmReskinRoute = '/onboarding/create-account/confirm';
export const onboardingThankYouReskinRoute = '/onboarding/create-account/thank-you';
export const onboardingFailureRoute = '/onboarding/create-account/failure';
export const onboardingFicaProcessingRoute = '/onboarding/create-account/fica-processing';
export const onboardingCreateAccountRedirect = '/onboarding/create-account/redirect';

export const onboardingBusinessDetailsDirectorsAddress =
  '/onboarding/create-account/your-directors-address';
export const onboardingYourDetailsCustomersAddress =
  '/onboarding/create-account/your-details-address';
export const onboardingYourDetailsMoreDetails = '/onboarding/create-account/more-details';

export const onboardingPostDistributionOtp = '/onboarding/otp';
export const onboardingChoosePaymentTypes = '/onboarding/create-account/payment-type';
export const onboardingPendingApplication = '/onboarding/create-account/pending-app';
